import React from "react"

interface IButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    // variant: 'yellow' | 'green';
    // onClick: (event: React.MouseEvent<HTMLButtonElement>) => void
}


const Button: React.FC<IButtonProps> = (props) => {
    const btnHandler = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>)=>{
        if (props.disabled) {
            event.preventDefault();
        } else {
            props.onClick !== undefined && props.onClick(event);
        }
    }
    
    return(
        <button type={props.type} title={props.title} className={`inline-block px-6 py-2.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md
            hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg 
            transition duration-150 ease-in-out ${props.disabled? "opacity-60 pointer-events-none" : "" } ${props.className}`}
            onClick={btnHandler}>
            {props.children}
        </button>
        )
}

export default Button